import { useState, useRef } from "react"

import Grid from '@material-ui/core/Grid'
import TextField from '@base/Inputs/Text'
import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"

import Toast from '@base/Toast'
import EscolaService from "@services/EscolaService"

export const InvalidarEscolaDialog = (props) => {
	const toastRef = useRef(null);
	const [mensagem, setMensagem] = useState([]);

	const submit = () => {
		let obj = {justificativa: mensagem};
		
		if(mensagem === undefined || mensagem === ""){
			toastRef.current.show("error", "Justificativa é obrigatória");
		}else{
		
			EscolaService.invalidar(props.processo,props.id,obj).then(ret => {
				props.aoSalvar();
				toastRef.current.show("success","Escola invalidada com sucesso!");
				limparFormulario();
			}).catch(error => {
				toastRef.current.show("error", "Ocorreu um Problema ao invalidar a escola:" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
			});
		}
	}

	const limparFormulario = () => {
		setMensagem([]);
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}
	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={props.aberto}
				title="Invalidar Escola"
				actions={<ButtonSave onClick={submit} />}>

				<Grid container spacing={12}>
					<Grid item sm={9}>
						<TextField
							label='Justificativa'
							required
							multiline
							minRows={4}
							maxRows={4}
							value={mensagem}
							name="mensagem"
							autoComplete="off"
							onChange={(e) => setMensagem(e.target.value)}
							/>
					</Grid>
				</Grid>
			</Dialog>
		</>
	);
}

export default InvalidarEscolaDialog;
